import { COMPARABLE_FIRMWARE } from '../../constants';
import type { Drone } from '../../types';

export type FirmwareCompliance = { compliant: number; total: number };

export const getFirmwareCompliance = (drones: Drone[]): FirmwareCompliance => {
    let compliant = 0;
    let total = 0;

    drones.forEach(drone => {
        COMPARABLE_FIRMWARE.forEach(component => {
            total += 1;

            if (drone.firmware[component] === 'compliant') {
                compliant += 1;
            }
        });
    });

    return { compliant, total };
};
